import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useAuth } from "../../providers/AuthProvider";
import { sendFeedback } from "../../api/feedbackApi";

function generateSubject(appName) {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const dateStr = `${yyyy}${mm}${dd}`;
  const counterKey = `feedbackCounter_${appName}_${dateStr}`;
  const current = parseInt(localStorage.getItem(counterKey) || "0", 10) + 1;
  localStorage.setItem(counterKey, String(current));
  return `${appName}改善要望_${dateStr}_${current}`;
}

export default function FeedbackDialog({ open, onClose, appName = "myCompany-manager" }) {
  const { company, memberEmail } = useAuth();
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleClose = () => {
    setBody("");
    setError("");
    setSuccess(false);
    onClose();
  };

  const handleSend = async () => {
    if (!body.trim()) {
      setError("本文を入力してください。");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const subject = generateSubject(appName);
      const senderName = company?.companyName
        ? company.companyName
        : (memberEmail || "");
      const senderEmail = memberEmail || "";
      await sendFeedback(subject, body, senderEmail, senderName);
      setSuccess(true);
    } catch (err) {
      setError("送信に失敗しました: " + (err.message || "不明なエラー"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>改善要望</DialogTitle>
      <DialogContent>
        {success ? (
          <Alert severity="success" sx={{ mt: 1 }}>
            改善要望を送信しました。ありがとうございます。
          </Alert>
        ) : (
          <>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            <TextField
              label="本文"
              multiline
              rows={6}
              value={body}
              onChange={(e) => setBody(e.target.value)}
              fullWidth
              margin="normal"
              placeholder="改善要望の内容を入力してください。"
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          {success ? "閉じる" : "キャンセル"}
        </Button>
        {!success && (
          <Button
            onClick={handleSend}
            variant="contained"
            disabled={loading}
            startIcon={loading ? <CircularProgress size={16} /> : null}
          >
            送信
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
